import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Clearfix } from 'react-bootstrap';

import NutrientSelect from '../common/NutrientSelect';
import GroupSelect from '../common/GroupSelect';

/**
 * Concerns of this component:
 *   control values in the forms (child components)
 *   to generate and pass query when submit
**/
class MultiNutrientQueryBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codes: this.props.selectedComponents ? this.props.selectedComponents : [],
      group: this.props.selectedGroup || 'all',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setNutrientCode = this.setNutrientCode.bind(this);
    this.setGroup = this.setGroup.bind(this);
  }

  // to update forms when navigated via history.
  componentWillReceiveProps(nextProps) {
    if(this.props !== nextProps) {
      this.setState({
        codes: nextProps.selectedComponents ? nextProps.selectedComponents : [],
        group: nextProps.selectedGroup || 'all',
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    // pass query to MultiNutrientSearch
    this.props.handleSubmit({
      // delete empty elements and create a string
      code: this.state.codes.join(','),
      group: this.state.group === 'all' ? '' : this.state.group,
    });
  }

  setNutrientCode(newCodes) {
    this.setState({codes: newCodes});
  }

  setGroup(newGroup) {
    this.setState({group: newGroup});
  }

  render() {
    const { components, groups } = this.props;

    // workaround to limit selections up to 3.
    // 'selected' does not work when there is no change to props.
    // Typeahead does not have options to limit selection.
    let options = components;
    let emptyLabel = '';
    if (this.state.codes.length >= 3) {
      options = this.state.codes.map(code => components.find(component => component.code === code));
      emptyLabel = 'Up to 3 nutrients can be selected.';
    }

    return (
      <div className="MultiNutrientQueryBuilder">
        <p>
          Generate a list of foods and the amount of each of the selected nutrients (up to 3).
          The list can be sorted by each of the selected nutrients.
        </p>

        <form onSubmit={this.handleSubmit}>
          <Col sm={12} md={6}>
            <NutrientSelect
              components={options}
              selected={this.state.codes}
              multiple
              label='Select nutrients'
              placeholder='Type to filter selection; e.g. Vitamin C'
              emptyLabel={emptyLabel}
              setNutrientCode={this.setNutrientCode}/>
          </Col>
          <Col sm={12} md={6}>
            <GroupSelect
              groups={groups}
              selected={this.state.group}
              setGroup={this.setGroup}/>
          </Col>
          <Col sm={12} className="searchButton">
            <Button type="submit" bsStyle="primary">GO</Button>
          </Col>
          <Clearfix />
        </form>

      </div>
    );
  }
}

MultiNutrientQueryBuilder.propTypes = {
  components: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  selectedComponents: PropTypes.array,
  selectedGroup: PropTypes.string,
  handleSubmit: PropTypes.func,
};

export default MultiNutrientQueryBuilder;



// WEBPACK FOOTER //
// ./src/components/search/multiNutrient/MultiNutrientQueryBuilder.js